import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  z-index: 1;

  h1 {
    color: #fff;
    font-size: 40px;
    margin: 8px;
    letter-spacing: 2px;
    margin-bottom: 16px;
  }

  form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 8px;
    min-width: 600px;

    input {
      width: 80%;
      margin-bottom: 8px;
      padding: 12px 16px;
      border-radius: 4px;
      border: 1px solid #fff;
      font-size: 16px;
      color: #fff;
      transition: border-color 0.2s;
      background-color: transparent;

      &:focus {
        border-color: #007fff;
      }
    }

    input.error {
      border-color: #ff3333;
    }

    textarea.error {
      border-color: #ff3333;
    }

    .input-feedback {
      color: #ff3333;
      margin-top: 4px;
    }

    textarea {
      min-height: 140px;
      width: 80%;
      margin-bottom: 8px;
      padding: 12px 16px;
      border-radius: 4px;
      border: 1px solid #fff;
      color: #fff;
      transition: border-color 0.2s;
      background-color: transparent;

      &:focus {
        border-color: #007fff;
      }
    }

    button {
      position: relative;
      display: block;
      width: 220px;
      text-align: center;
      padding: 8px;
      margin: 8px;
      color: #007fff;
      font-size: 16px;
      font-weight: 700;
      overflow: hidden;
      transition: 0.2s;
      letter-spacing: 2px;
      background-color: transparent;
      border: 1px solid #007fff;
    }

    button.send:hover {
      background: #007fff;
      color: #fff;
      box-shadow: 0 0 8px #007fff;
    }

    button:disabled {
      opacity: 0.2;
      cursor: not-allowed !important;
    }

    /* button.outline {
      background-color: #eee;
      border: 1px solid #aaa;
      color: #555;
    } */

    @media (max-width: 767px) {
      min-width: 375px;
    }
  }
`;
